import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getOneModulo, actualizarModulo } from "../../../services/modulo.service";
import { getAllIdiomas } from "../../../services/idioma.service";
import { getAllNiveles } from "../../../services/nivel.service";
import {
  showErrorAlert,
  showActualizadoCorrectamenteAlert
} from "../../../components/molecules/ShowAlert";

export const ActualizarModulo = () => {
  const { idModulo } = useParams();
  const navigate = useNavigate();
  const [modulo, setModulo] = useState({});
  const [idiomas, setIdiomas] = useState([]);
  const [niveles, setNiveles] = useState([]);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [moduloData, idiomasData, nivelesData] = await Promise.all([
          getOneModulo(idModulo),
          getAllIdiomas(),
          getAllNiveles()
        ]);
        setModulo(moduloData);
        setIdiomas(idiomasData);
        setNiveles(nivelesData);
      } catch (error) {
        console.error("Error al cargar datos del módulo:", error);
        showErrorAlert();
      }
    };

    cargarDatos();
  }, [idModulo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setModulo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await actualizarModulo(idModulo, modulo);
      showActualizadoCorrectamenteAlert({
        callback: () => navigate("/idiomas/VerModulos")
      });
    } catch (error) {
      console.error("Error al actualizar módulo:", error);
      showErrorAlert();
    }
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-semibold mb-6">Actualizar Módulo</h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        <div>
          <label className="block font-medium">Nombre</label>
          <input
            type="text"
            name="nombre"
            value={modulo.nombre || ""}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Sigla</label>
          <input
            type="text"
            name="sigla"
            value={modulo.sigla || ""}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Idioma</label>
          <select
            name="idIdioma"
            value={modulo.idIdioma || ""}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          >
            <option value="">Seleccione un idioma</option>
            {idiomas.map((idioma) => (
              <option key={idioma.idIdioma} value={idioma.idIdioma}>
                {idioma.nombre}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Idioma actual: {idiomas.find(i => i.idIdioma === modulo.idIdioma)?.nombre || "No seleccionado"}
          </p>
        </div>

        <div>
          <label className="block font-medium">Nivel</label>
          <select
            name="idNivel"
            value={modulo.idNivel || ""}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          >
            <option value="">Seleccione un nivel</option>
            {niveles.map((nivel) => (
              <option key={nivel.idNivel} value={nivel.idNivel}>
                {nivel.nombre}
              </option>
            ))}
          </select>
          <p className="text-sm text-gray-500 mt-1">
            Nivel actual: {niveles.find(n => n.idNivel === modulo.idNivel)?.nombre || "No seleccionado"}
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={() => navigate("/idiomas/VerModulos")}
            className="bg-gray-400 hover:bg-gray-600 text-white font-semibold px-6 py-2 rounded"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-theme-yellow hover:bg-yellow-500 text-white font-semibold px-6 py-2 rounded"
          >
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
  );
};
